import * as yup from "yup";

export const commentSchema = yup.object({
	name: yup.string().required("Name is required"),
	email: yup.string().email().required("Email is required"),
	comment: yup.string(),
	response: yup.number().required("Response is required")
});
